var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { checkValue, roundUpToTwoDecimalPlaces, } from "@domains/utils/numberMethods";
export var dashboardHoldingMapper = function (data) {
    if (data) {
        var holdingDashboardSummary = data.holdingDashboardSummary.map(function (x) {
            return {
                assetClass: x.assetClass,
                investmentValue: String(checkValue(x.investmentValue)),
                marketValue: String(checkValue(x.marketValue)),
                pnl: String(checkValue(x.pnl)),
                pnlPercent: String(checkValue(x.pnlPercent)),
                totalHoldingPrc: String(checkValue(x.totalHoldingPrc)),
            };
        });
        var holdingDetail = data.holdingDetail.map(function (x) {
            return {
                scripName: x.scripName,
                quantity: x.quantity,
                longTermQuantity: x.longTermQuantity,
                averagePrice: x.averagePrice,
                investmentValue: x.investmentValue,
                currentValue: x.currentValue,
                pnl: x.pnl,
                pnlChangePercentage: x.pnlChangePercentage,
                dayChange: x.dayChange,
                freeQuantity: x.freeQuantity,
                normalMarginPledge: x.normalMarginPledge,
                lockedInQuantity: x.lockedInQuantity,
                cusa: x.cusa,
                mtfPledge: x.mtfPledge,
                t1: x.t1,
                t1Mtf: x.t1Mtf,
                lasPledge: x.lasPledge,
                sebiMtfHoldQuantity: x.sebiMtfHoldQuantity,
                safeKeepQuantity: x.safeKeepQuantity,
                soldQuantity: x.soldQuantity,
                tradableQuantity: x.tradableQuantity,
                previousClosingValue: x.previousClosingValue,
                quote: x.quote,
                filterFlags: x.filterFlags,
                earMarkedQuantity: x.earMarkedQuantity,
                thirdPartyPledge: x.thirdPartyPledge,
                sector: x.sector,
                corpAction: x.corpAction,
                corpActionType: x.corpActionType,
                corpActionDesc: x.corpActionDesc,
                edelweissProduct: x.edelweissProduct,
                edelweissAssetClass: x.edelweissAssetClass,
                displayName: x.quote.displayName,
                changePercentage: roundUpToTwoDecimalPlaces(Number(x.quote.changePercentage)),
                scripIdentifier: x.scripIdentifier,
                rating: x.rating,
                ratingAgent: x.ratingAgent,
            };
        });
        return __assign(__assign({}, data), { holdingDetail: holdingDetail, holdingDashboardSummary: holdingDashboardSummary, isOmneOnly: !!(data === null || data === void 0 ? void 0 : data.isOmneOnly) });
    }
    else {
        return null;
    }
};
